import { queryParamHookFactory } from 'modules/taboola-common-frontend-modules/query-params';

export const INITIAL_CREATIVE_TYPE = 'initialCreativeType';

/**
 * @deprecated - this hook can't be sued anymore and will be removed once migrated to unified solution for image and motion
 */
export const useInitialCreativeType = queryParamHookFactory(INITIAL_CREATIVE_TYPE);
